<style type="text/css">
.absolute-divs {
  margin: 0;
  padding: 0;
  z-index: 2;
  position: absolute;
  transform:translate(-50%, 0);
  width: 71.2%;
  left: 50%;
}
.title-container {
  height: 10.45%;
  top: 13.52%;
 -webkit-transition: opacity 300ms ease-in-out;
  -moz-transition: opacity 300ms ease-in-out;
  -o-transition: opacity 300ms ease-in-out;
  transition: opacity 300ms ease-in-out;
}
h1.main-title{
  text-align: left;
  display:block;
  line-height: 1.19;
}
p.counter {
  display:block;
  font-family: "Campton-Light";
  text-align: left;
  margin-left: 16px;
  margin-top: 16px;
  letter-spacing: 5px;

}
p.sub-title {
  text-align: left;
  margin-top: 8px;
}
</style>
<div class="absolute-divs title-container">
  <h1 class="main-title">{{question}}</h1>
  <p class="counter"><span data-testid="rating-counter-current" class="current">{{currentItem + 1}}</span>/<span data-testid="rating-counter-max" class="max">{{ count }}</span></p>
  <div class="clearfix"></div>
</div>
